<script setup lang="ts">
  import type { MatchStakeholdersRequestResponse } from '@gat-ship/types'
  import { IconMail, IconPhone } from '@gat-ship/icons'
  import { useFormatting } from '@gat-ship/utils'
  import { Badge, useModalStack } from '@gat-ship/vue-components'

  const { formatPhoneNumber } = useFormatting()
  const stack = useModalStack()

  defineProps<{
    candidates: MatchStakeholdersRequestResponse['candidates']
  }>()
</script>
<template>
  <div class="flex flex-col gap-4">
    <div
      v-for="candidate in candidates"
      :key="candidate.id"
      class="bg-border flex flex-col gap-4 rounded-sm p-2 text-xs"
    >
      <div class="flex flex-col gap-2">
        <div class="flex w-full flex-col gap-0">
          <div class="flex flex-row items-center gap-2">
            <div class="text-sm font-medium tracking-wide">
              <button
                class="hover:text-link hover:underline"
                @click="
                  stack.open('stakeholder', {
                    id: candidate.id,
                    stakeholderType: candidate.stakeholderType
                  })
                "
              >
                {{ candidate.name }}
              </button>
            </div>
            <badge
              v-if="candidate.isInactive"
              class="bg-muted border-border text-muted-foreground w-fit"
              >Inactive
            </badge>
          </div>
          <span v-if="candidate.shortName" class="text-xs font-normal">{{
            candidate.shortName
          }}</span>
        </div>
        <div v-if="candidate.email" class="inline-flex items-center gap-1">
          <icon-mail class="size-4" />
          {{ candidate.email }}
        </div>
        <div
          v-if="candidate.phoneNumber"
          class="inline-flex items-center gap-1"
        >
          <icon-phone class="size-4" />
          {{ formatPhoneNumber(candidate.phoneNumber) }}
        </div>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col gap-1">
          <div class="text-muted-foreground">Client Number</div>
          <div class="inline-flex items-center gap-1">
            {{ candidate.clientNumber ?? '-' }}
          </div>
        </div>
        <div class="flex flex-col gap-1">
          <div class="text-muted-foreground">Vendor Number</div>
          <div class="inline-flex items-center gap-1">
            {{ candidate.vendorNumber ?? '-' }}
          </div>
        </div>
        <div class="flex flex-col gap-1">
          <div class="text-muted-foreground">Tax Identification Number</div>
          <div class="inline-flex items-center gap-1">
            {{ candidate.taxIdentificationNumber ?? '-' }}
          </div>
        </div>
        <div class="flex flex-col gap-1">
          <div class="text-muted-foreground">EORI Number</div>
          <div class="inline-flex items-center gap-1">
            {{ candidate.eoriNumber ?? '-' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
